// Object -> [Object] -> Object(OrganizationCode) | null
import { Text } from "@chakra-ui/react";

export function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

export function formatDateDDMMYYYY(date) {
  const utcDate = new Date(date);
  const options = { day: "numeric", month: "numeric", year: "numeric" };
  return utcDate.toLocaleDateString(undefined, options);
}

export function formatTime(date) {
  const utcDate = new Date(date);
  const options = { hour: "numeric", minute: "numeric", hour12: true };
  return utcDate.toLocaleString(undefined, options);
}

export function getFutureDate(days) {
  let myCurrentDate = new Date();
  let myFutureDate = new Date(myCurrentDate);
  myFutureDate.setDate(myFutureDate.getDate() + days); //myFutureDate is now 8 days in the future
  return myFutureDate;
}

export function validatePassword(password) {
  const re =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\[\]{}\(\)?\-\"!@#%&\/,><\':;|_~`])\S{8,99}$/;
  return re.test(String(password));
}

export function validatePhone(phone) {
  const re = /^\d{10}$/;
  return re.test(Number(phone));
}

export function isStringIsEmail(str) {
  const regexExp =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gi;
  return regexExp.test(str);
}

export function createColumns(headers) {
  return headers.map((header) => ({
    Header: header.name,
    accessor: header.accessor,
    ...(header.Cell
      ? { Cell: header.Cell }
      : {
          Cell: ({ cell: { value } }) => <Text>{value}</Text>,
        }),
  }));
}

export function generateString(length) {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let result = "";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
}
